import { __assign, __awaiter, __generator, __read, __spreadArray } from "tslib";
import { StoreMetaDataApi } from '../../apis/StoreMetaDataApi/StoreMetaDataApi';
import { getEcommerceSettings } from '@wix/ambassador-ecom-v1-ecommerce-settings/http';
import { RequestedFields, } from '@wix/ambassador-ecom-v1-ecommerce-settings/types';
import { canBusinessShip, hasAdditionalFees, hasValidationsInCart } from './eCommerceSettingsService.utils';
import { SPECS } from '../../constants';
var CACHE_KEY = 'PURCHASE_FLOW_PROPERTIES';
var ECOMMERCE_SETTINGS_CACHE_KEY = 'SPI_CONFIG_PROPERTIES';
var ECOMMERCE_SETTINGS_WARMUP_DATA_KEY = 'ECOMMERCE_SETTINGS_WARMUP_DATA';
var origin = 'prefetch-purchase-flow-properties';
var EcommerceSettingsService = /** @class */ (function () {
    function EcommerceSettingsService(_a) {
        var context = _a.context, apis = _a.apis, platformServices = _a.platformServices;
        this.apis = apis;
        this.storeMetaDataApi = new StoreMetaDataApi({
            siteStore: context.siteStore,
            origin: origin,
        });
        this.siteStore = context.siteStore;
        this.httpClient = platformServices.essentials.httpClient;
    }
    EcommerceSettingsService.prototype.init = function () {
        this.purchaseFlowPropertiesPromise = this.getPurchaseFlowPropertiesFromServerOrCache();
        this.ecommerceSettingsPromise = this.getEcommerceSettingsFromServerOrCache();
    };
    EcommerceSettingsService.prototype.getPurchaseFlowProperties = function () {
        if (!this.purchaseFlowPropertiesPromise) {
            this.purchaseFlowPropertiesPromise = this.getPurchaseFlowPropertiesFromServerOrCache();
        }
        return this.purchaseFlowPropertiesPromise;
    };
    EcommerceSettingsService.prototype.getEcommerceSettings = function (_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
        var _x = _a === void 0 ? {} : _a, shouldWarmupData = _x.shouldWarmupData;
        return __awaiter(this, void 0, void 0, function () {
            var shouldUseAdditionalEcommerceSettings, ecommerceSettingsResponse;
            return __generator(this, function (_y) {
                switch (_y.label) {
                    case 0:
                        if (!this.ecommerceSettingsPromise) {
                            this.ecommerceSettingsPromise = this.getEcommerceSettingsFromServerOrCache({ shouldWarmupData: shouldWarmupData });
                        }
                        shouldUseAdditionalEcommerceSettings = this.siteStore.experiments.enabled(SPECS.UseAdditionalEcommerceSettings);
                        return [4 /*yield*/, this.ecommerceSettingsPromise];
                    case 1:
                        ecommerceSettingsResponse = _y.sent();
                        return [2 /*return*/, __assign({ hasAdditionalFees: hasAdditionalFees(ecommerceSettingsResponse), hasValidationsInCart: hasValidationsInCart(ecommerceSettingsResponse) }, (shouldUseAdditionalEcommerceSettings
                                ? {
                                    isPremium: Boolean((_b = ecommerceSettingsResponse.ecommerceSettings) === null || _b === void 0 ? void 0 : _b.premiumSite),
                                    delivery: {
                                        canBusinessShip: canBusinessShip(ecommerceSettingsResponse),
                                        destinationScope: (_d = (_c = ecommerceSettingsResponse.ecommerceSettings) === null || _c === void 0 ? void 0 : _c.delivery) === null || _d === void 0 ? void 0 : _d.destinationScope,
                                        destinations: (_g = (_f = (_e = ecommerceSettingsResponse.ecommerceSettings) === null || _e === void 0 ? void 0 : _e.delivery) === null || _f === void 0 ? void 0 : _f.destinations) !== null && _g !== void 0 ? _g : [],
                                        postalCodeRequired: Boolean((_j = (_h = ecommerceSettingsResponse.ecommerceSettings) === null || _h === void 0 ? void 0 : _h.delivery) === null || _j === void 0 ? void 0 : _j.postalCodeRequired),
                                    },
                                    tax: {
                                        taxIncludedInItemPrices: Boolean((_l = (_k = ecommerceSettingsResponse.ecommerceSettings) === null || _k === void 0 ? void 0 : _k.tax) === null || _l === void 0 ? void 0 : _l.taxIncludedInItemPrices),
                                    },
                                    businessInfo: {
                                        storeName: (_o = (_m = ecommerceSettingsResponse.ecommerceSettings) === null || _m === void 0 ? void 0 : _m.businessInfo) === null || _o === void 0 ? void 0 : _o.name,
                                        logo: (_q = (_p = ecommerceSettingsResponse.ecommerceSettings) === null || _p === void 0 ? void 0 : _p.businessInfo) === null || _q === void 0 ? void 0 : _q.logo,
                                    },
                                    checkoutSettings: {
                                        checkoutPolicies: __assign({}, (_s = (_r = ecommerceSettingsResponse.ecommerceSettings) === null || _r === void 0 ? void 0 : _r.checkout) === null || _s === void 0 ? void 0 : _s.checkoutPolicies),
                                        checkoutFields: __assign({}, (_u = (_t = ecommerceSettingsResponse.ecommerceSettings) === null || _t === void 0 ? void 0 : _t.checkout) === null || _u === void 0 ? void 0 : _u.checkoutFields),
                                        checkoutBrand: __assign({}, (_w = (_v = ecommerceSettingsResponse.ecommerceSettings) === null || _v === void 0 ? void 0 : _v.checkout) === null || _w === void 0 ? void 0 : _w.checkoutBrand),
                                    },
                                }
                                : {}))];
                }
            });
        });
    };
    EcommerceSettingsService.prototype.getPurchaseFlowPropertiesFromServerOrCache = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cachedProperties, storeMetaData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cachedProperties = this.apis.storage.memory.getItem(CACHE_KEY);
                        if (cachedProperties) {
                            return [2 /*return*/, JSON.parse(cachedProperties)];
                        }
                        return [4 /*yield*/, this.storeMetaDataApi.getStoreMetaData()];
                    case 1:
                        storeMetaData = _a.sent();
                        this.apis.storage.memory.setItem(CACHE_KEY, JSON.stringify({ storeMetaData: storeMetaData }));
                        return [2 /*return*/, { storeMetaData: storeMetaData }];
                }
            });
        });
    };
    EcommerceSettingsService.prototype.getEcommerceSettingsFromServerOrCache = function (_a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, shouldWarmupData = _c.shouldWarmupData;
        return __awaiter(this, void 0, void 0, function () {
            var cachedProperties, shouldUseAdditionalEcommerceSettings, ecommerceSettings, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        cachedProperties = this.apis.storage.memory.getItem(ECOMMERCE_SETTINGS_CACHE_KEY);
                        shouldUseAdditionalEcommerceSettings = this.siteStore.experiments.enabled(SPECS.UseAdditionalEcommerceSettings);
                        if (cachedProperties) {
                            return [2 /*return*/, JSON.parse(cachedProperties)];
                        }
                        if (!((_b = this.getWarmupEcommerceSettings()) !== null && _b !== void 0)) return [3 /*break*/, 1];
                        _d = _b;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.httpClient.request(getEcommerceSettings({
                            fields: __spreadArray([
                                RequestedFields.ADDITIONAL_FEES_SERVICE_PLUGIN,
                                RequestedFields.VALIDATIONS_SERVICE_PLUGIN
                            ], __read((shouldUseAdditionalEcommerceSettings
                                ? [
                                    RequestedFields.TAX,
                                    RequestedFields.CHECKOUT,
                                    RequestedFields.BUSINESS_INFO,
                                    RequestedFields.DELIVERY,
                                    RequestedFields.PREMIUM_SITE,
                                ]
                                : [])), false),
                        }))];
                    case 2:
                        _d = (_e.sent()).data;
                        _e.label = 3;
                    case 3:
                        ecommerceSettings = _d;
                        this.apis.storage.memory.setItem(ECOMMERCE_SETTINGS_CACHE_KEY, JSON.stringify(ecommerceSettings));
                        if (shouldWarmupData && this.siteStore.isSSR()) {
                            this.siteStore.windowApis.warmupData.set(ECOMMERCE_SETTINGS_WARMUP_DATA_KEY, ecommerceSettings);
                        }
                        return [2 /*return*/, ecommerceSettings];
                }
            });
        });
    };
    EcommerceSettingsService.prototype.getWarmupEcommerceSettings = function () {
        var warmupEcommerceSettings = this.siteStore.windowApis.warmupData.get(ECOMMERCE_SETTINGS_WARMUP_DATA_KEY);
        if (warmupEcommerceSettings) {
            this.siteStore.windowApis.warmupData.set(ECOMMERCE_SETTINGS_WARMUP_DATA_KEY, undefined);
        }
        return warmupEcommerceSettings;
    };
    return EcommerceSettingsService;
}());
export { EcommerceSettingsService };
//# sourceMappingURL=EcommerceSettingsService.js.map